<template>
  <SubmenuDropdownList>
    <NavigationMenuContent
      :link-sections="linkSections"
      :columns="columns"
      :get-query-param="getQueryParam"
    >
      <template #header="{ name }">
        <SubmenuDropdownListItem
          header
        >
          {{ name }}
        </SubmenuDropdownListItem>
      </template>

      <template
        #item="{
          title, isBeta, isSoon, isUpgrade, isNew,
        }"
      >
        <SubmenuDropdownListItem
          v-bind="{
            isBeta, isSoon, isUpgrade, isNew,
          }"
          @click="$emit('tracking-event', {
            action: 'navLinkClick',
            args: { label: title },
          })"
        >
          <div class="navigation-text">
            {{ title }}
          </div>
        </SubmenuDropdownListItem>
      </template>
    </NavigationMenuContent>
  </SubmenuDropdownList>
</template>

<script setup>
import SubmenuDropdownList from '@/components/editor/SubmenuDropdownList.vue';
import SubmenuDropdownListItem from '@/components/editor/SubmenuDropdownListItem.vue';
import NavigationMenuContent from '@/components/shared/NavigationMenuContent.vue';

defineProps({
  columns: { type: Number, default: 3 },
  linkSections: { type: Array, default: () => [] },
  getQueryParam: { type: Function, default: () => ({}) },
  minWidth: { type: Number, default: 220 },
});

defineEmits(['tracking-event']);
</script>

<style scoped lang="less">
.router-link-active {
  .navigation-text {
    text-decoration: underline;
  }
}
</style>
